import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import ManageScope from '@/ui/pages/UserAccess/ManageScope';

export const Route = createFileRoute('/_dashboard/users/$id/$tenantId/access/')({
  beforeLoad: requireRoute('/users/$id/$tenantId/access'),
  component: ManageScope,
});
